import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FormRow, FormRowLabel, FormRowMessage, FormRowText, FormCheckbox, GdprCheckboxes, Alert, TitleStack, BlockButton, Card } from "fiver-react-ui-components";
const StyledWrapper = styled.div``;
const StyledButton = styled.button`
  display: inline-block;
  font-size: inherit;
  padding: 0;
  color: ${props => props.theme.colorAccent === "#000000" ? props.theme.colorAccentText : props.theme.colorAccent};
`;
const StyledSmallButton = styled.button`
  display: inline-block;
  font-size: 14px;
  padding: 0;
  color: ${props => props.theme.colorAccent === "#000000" ? props.theme.colorAccentText : props.theme.colorAccent};
  margin-bottom: 1rem;
`;
const StyledMailTo = styled.a`
  && {
    display: inline-block;
    font-size: inherit;
    padding: 0;
    color: ${props => props.theme.colorAccent === "#000000" ? props.theme.colorAccentText : props.theme.colorAccent};
  }
`;
const StyledCardHeaderSmall = styled.div`
  font-size: 0.875rem;
  margin-bottom: 1rem;
`;
const StyledUl = styled.ul`
  margin: 0 0 2rem;
  padding: 0.75rem 0 0 1rem;
`;
const StyledLi = styled.li`
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
  line-height: 1.3;
`;

const SignupStep = ({
  translations,
  isSubmitting,
  onPageButtonClicked,
  onStepClicked,
  setValues,
  isStepValid,
  isNonUk,
  values,
  errors,
  dirty,
  handleChange,
  signupError,
  termsSlug,
  privacySlug,
  handleBlur,
  useAssetsCdn,
  showHasTotoAccountCheckbox,
  hideGdprCheckboxes,
  hideSmsCheckbox,
  hideEmailCheckbox,
  hideCheckAllCheckbox,
  gameRulesSlug,
  tenantDetails,
  hideDataShareCheckbox
}) => {
  useEffect(() => {
    window.xtremepush("tag", "registration_contact_permissions", JSON.stringify({
      AppName: process.env.REACT_APP_TITLE
    }));

    if (values.country !== "United Kingdom") {
      setValues({ ...values,
        emailNotificationsAccepted: true
      });
    }

    if (!isNonUk) {
      setValues({ ...values,
        inAppNotificationsAccepted: false,
        smsNotificationsAccepted: false,
        emailNotificationsAccepted: false,
        agreedPrivacy: false,
        agreedTerms: false
      });
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  const [checkAll, setCheckAll] = useState(false);
  const [dataShareCheckbox, setDataShareCheckbox] = useState();
  useEffect(() => {
    const tenant = tenantDetails?.complianceName || tenantDetails?.name;
    const message = `Please confirm if you are happy for us to share your name, email address and phone number with our brand partner, [Legal Tenant], for the purpose of enabling [Legal Tenant] to email you about their products and services.If you change your mind, please contact [Legal Tenant] directly so that they can update your preference.`.replace(/\[Legal Tenant\]/g, tenant);
    setDataShareCheckbox(message);
  }, [tenantDetails?.complianceName, tenantDetails?.name]);

  const handleCheckAllChecked = e => {
    if (e.target.checked) {
      setCheckAll(true);
      setValues({ ...values,
        inAppNotificationsAccepted: true,
        smsNotificationsAccepted: true,
        emailNotificationsAccepted: true,
        agreedTerms: true,
        agreedPrivacy: true,
        dataSharePermissions: true
      });
    } else {
      setCheckAll(false);
      setValues({ ...values,
        inAppNotificationsAccepted: false,
        smsNotificationsAccepted: false,
        emailNotificationsAccepted: false,
        agreedTerms: false,
        agreedPrivacy: false,
        dataSharePermissions: false
      });
    }
  };

  const confirmTerms = () => {
    if (values.country !== "United Kingdom") {
      setValues({ ...values,
        agreedPrivacy: true
      });
      onStepClicked(4);
    } else {
      onStepClicked(4);
    }
  };

  const handleEmailConsent = e => {
    if (e.target.checked) {
      setValues({ ...values,
        emailNotificationsAccepted: true
      });
    } else {
      setValues({ ...values,
        emailNotificationsAccepted: false
      });
    }
  };

  const NonUkPreferences = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(TitleStack, {
      title: `${translations.step} 4`,
      subtitle: translations.preferences,
      id: "step-title"
    }), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormCheckbox, {
      id: "email-notification-checkbox",
      isSmallerText: true,
      name: "emailNotificationsAccepted",
      alignItems: "center",
      checked: values.emailNotificationsAccepted,
      label: translations.emailNotificationsAccepted.replace("$1", tenantDetails?.complianceName),
      onChange: e => {
        window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
          AppName: process.env.REACT_APP_TITLE
        }));
        handleChange(e);
        handleEmailConsent(e);
      },
      onBlur: handleBlur
    })), tenantDetails?.partnerName && /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormCheckbox, {
      id: "partner-notification-checkbox",
      isSmallerText: true,
      name: "partnerNotificationAccepted",
      alignItems: "center",
      checked: values.partnerNotificationAccepted,
      label: "Yes, I would like to receive future promotions from " + tenantDetails?.partnerName,
      onChange: e => {
        window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
          AppName: process.env.REACT_APP_TITLE
        }));
        handleChange(e);
      },
      onBlur: handleBlur
    })), tenantDetails?.affiliateName && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormCheckbox, {
      id: "affiliate-notification-checkbox",
      isSmallerText: true,
      name: "affiliateNotificationAccepted",
      alignItems: "center",
      checked: values.affiliateNotificationAccepted,
      label: `${translations.affiliateLabel} ${tenantDetails?.affiliateName}`,
      onChange: e => {
        window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
          AppName: process.env.REACT_APP_TITLE
        }));
        handleChange(e);
      },
      onBlur: handleBlur
    })), showHasTotoAccountCheckbox && /*#__PURE__*/React.createElement(FormCheckbox, {
      id: "hastotoaccount-checkbox",
      isSmallerText: true,
      name: "hasTotoAccount",
      alignItems: "center",
      checked: values.hasTotoAccount,
      label: translations.hasTotoAccountCheckbox,
      onChange: handleChange,
      onBlur: handleBlur
    })), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(StyledCardHeaderSmall, {
      id: "terms-header"
    }, translations.termsAndPrivacy), /*#__PURE__*/React.createElement(FormRowLabel, null, translations.byJoiningMessage), /*#__PURE__*/React.createElement(StyledUl, null, /*#__PURE__*/React.createElement(StyledLi, {
      id: "over18message"
    }, translations.over18Message), /*#__PURE__*/React.createElement(StyledLi, null, translations.iAgree, " ", /*#__PURE__*/React.createElement(StyledButton, {
      id: "general-terms-btn",
      type: "button",
      onClick: () => onPageButtonClicked(termsSlug, "General Terms", useAssetsCdn)
    }, translations.generalTerms), " ", translations.and, " ", /*#__PURE__*/React.createElement(StyledButton, {
      id: "gamerules-btn",
      type: "button",
      onClick: () => onPageButtonClicked(gameRulesSlug, translations.gameRules, useAssetsCdn)
    }, translations.gameRules)), /*#__PURE__*/React.createElement(StyledLi, {
      id: "privacy-message"
    }, translations.privacyPolicyMessage, " ", /*#__PURE__*/React.createElement(StyledButton, {
      id: "privacy-policy-btn",
      type: "button",
      onClick: () => onPageButtonClicked(privacySlug, "Privacy Policy", useAssetsCdn)
    }, translations.privacyPolicy))), /*#__PURE__*/React.createElement(FormRowMessage, {
      margin: "0 0 1rem",
      isVisible: signupError !== undefined,
      id: "signup-error"
    }, signupError), /*#__PURE__*/React.createElement(BlockButton, {
      type: "submit",
      isSuccess: true,
      isLoading: isSubmitting,
      disabled: false,
      style: {
        marginBottom: "1rem"
      },
      id: "join-btn" // onClick={() => confirmTerms()}

    }, translations.joinNow), /*#__PURE__*/React.createElement(BlockButton, {
      onClick: () => onStepClicked(2),
      id: "back-btn"
    }, translations.back)));
  };

  const UkPreferences = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(TitleStack, {
      title: `${translations.step} 4`,
      subtitle: translations.preferences,
      id: "step-title"
    }), /*#__PURE__*/React.createElement(StyledCardHeaderSmall, {
      id: "terms-header"
    }, translations.termsConditions), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormCheckbox, {
      id: "terms-checkbox",
      name: "agreedTerms",
      alignItems: "center",
      isSmallerText: true,
      checked: values.agreedTerms,
      label: translations.confirmTermsConditions,
      onChange: e => {
        window.xtremepush("tag", "Profile.TermsAndConditions", JSON.stringify({
          AppName: process.env.REACT_APP_TITLE
        }));
        handleChange(e);
      },
      onBlur: handleBlur
    })), /*#__PURE__*/React.createElement(StyledSmallButton, {
      id: "terms-btn",
      type: "button",
      onClick: () => onPageButtonClicked(termsSlug, translations.termsConditions, useAssetsCdn)
    }, translations.termsConditions), /*#__PURE__*/React.createElement(StyledCardHeaderSmall, {
      id: "privacy-header"
    }, translations.privacyCookies), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormCheckbox, {
      id: "privacy-checkbox",
      isSmallerText: true,
      name: "agreedPrivacy",
      alignItems: "center",
      checked: values.agreedPrivacy,
      label: translations.confirmPrivacyPolicy,
      onChange: e => {
        window.xtremepush("tag", "Profile.TermsAndConditions", JSON.stringify({
          AppName: process.env.REACT_APP_TITLE
        }));
        handleChange(e);
      },
      onBlur: handleBlur
    })), /*#__PURE__*/React.createElement(StyledSmallButton, {
      id: "privacy-btn",
      type: "button",
      onClick: () => onPageButtonClicked(privacySlug, translations.privacyCookies, useAssetsCdn)
    }, translations.privacyCookies), !hideDataShareCheckbox && dataShareCheckbox && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledCardHeaderSmall, {
      id: "datasharing-header"
    }, translations.dataSharingConsent), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormCheckbox, {
      id: "datasharing-checkbox",
      isSmallerText: true,
      name: "dataSharePermissions",
      alignItems: "flex-start",
      checked: values.dataSharePermissions,
      label: dataShareCheckbox,
      onChange: handleChange,
      onBlur: handleBlur
    }))), /*#__PURE__*/React.createElement(StyledCardHeaderSmall, {
      id: "marketing-header"
    }, translations.marketing), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormRowText, {
      id: "gdpr-title"
    }, translations.insentiveMarketing)), !hideGdprCheckboxes && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GdprCheckboxes, {
      hidePushNotifcationCheckbox: true,
      hideSmsCheckbox: hideSmsCheckbox,
      hideEmailCheckbox: hideEmailCheckbox,
      message: translations.confirmMarketing,
      smsNotificationsAccepted: values.smsNotificationsAccepted,
      emailNotificationsAccepted: values.emailNotificationsAccepted,
      onChange: e => {
        window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
          AppName: process.env.REACT_APP_TITLE
        }));
        handleChange(e);
      },
      onBlur: handleBlur
    }), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormRowText, null, translations.messageConsentPart1, " ", /*#__PURE__*/React.createElement(StyledMailTo, {
      href: "mailto:privacy@low6.co.uk"
    }, "privacy@low6.co.uk"), translations.messageConsentPart2, /*#__PURE__*/React.createElement(StyledButton, {
      type: "button",
      onClick: () => onPageButtonClicked(privacySlug, "Privacy Policy", useAssetsCdn)
    }, translations.privacyPolicy))), !hideCheckAllCheckbox && /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormCheckbox, {
      id: "checkall-checkbox",
      isSmallerText: true,
      name: "checkAll",
      alignItems: "center",
      checked: checkAll && values.agreedTerms && values.agreedPrivacy && values.smsNotificationsAccepted && values.emailNotificationsAccepted,
      label: translations.confirmAgreeAll,
      onChange: handleCheckAllChecked,
      onBlur: handleBlur
    }))), errors.agreedTerms || errors.agreedPrivacy ? /*#__PURE__*/React.createElement(Alert, {
      isDanger: true,
      margin: "0 0 1rem",
      id: "agreement-alert"
    }, translations.messageTermsPrivacy) : null, /*#__PURE__*/React.createElement(BlockButton, {
      isLoading: isSubmitting,
      disabled: !isStepValid || !dirty || errors.agreedTerms || errors.agreedPrivacy,
      style: {
        marginBottom: "1rem"
      },
      onClick: () => confirmTerms(),
      id: "next-btn"
    }, translations.next), /*#__PURE__*/React.createElement(BlockButton, {
      onClick: () => onStepClicked(2),
      id: "back-btn"
    }, translations.back)));
  };

  return /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement(UkPreferences, null));
};

export default SignupStep;